import {createContext} from 'react';
import {TranslationsFlatMap} from './localesParser';

export interface LocalizerContextValue {
	translations: TranslationsFlatMap;
	language: string;
	setLanguage(langCode: string): void;
}

export const LocalizerContext = createContext<LocalizerContextValue | null>(null);
